import { render, staticRenderFns } from "./configurationsDefault.vue?vue&type=template&id=f1950bb0"
import script from "./configurationsDefault.vue?vue&type=script&lang=js"
export * from "./configurationsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports